<template>
  <step-item-wrapper @stepManagerState="setFrom">
    <div class="form-group">
      <label for="single-dashboard-quantity" v-t="`product.single.dashboard.quantity`"></label>
      <input v-model.lazy="formVModel" type="text" class="form-control" id="single-dashboard-quantity">
    </div>
  </step-item-wrapper>
</template>

<script>
import StepItemWrapper from "../../../StepItemWrapper.vue";

export default {
  name: "StepManagerFormProductQuantity",
  components: {StepItemWrapper},
  data() {
    return {
      form: {},
    }
  },
  computed: {
    formType() {
      return this.form.formType
    },
    formVModel: {
      get() {
        if (this.formType === 'product') {
          return this.form.quantity;
        }
      },
      set(value) {
        if (this.formType === 'product') {
          this.form.quantity = value;
        }
      },
    }
  },
  methods: {
    setFrom(value) {
      this.form = value
    }
  }
}
</script>


<style scoped>

</style>